import Vue from 'vue'
import OnsiteSearchApp from './OnsiteSearchApp.vue'
import { onsiteStore } from "./store/index";

Vue.config.productionTip = false
Vue.config.devtools = true;
Vue.prototype.Miele = window.Miele;

if (document.querySelector("#onsite-search-app")) {
  new Vue({
    store: onsiteStore,
    render: f => f(OnsiteSearchApp),
  }).$mount('#onsite-search-app')
}

